import { render, staticRenderFns } from "./CategoryFiltering.vue?vue&type=template&id=2196ac1e&"
import script from "./CategoryFiltering.vue?vue&type=script&lang=js&"
export * from "./CategoryFiltering.vue?vue&type=script&lang=js&"
import style0 from "./CategoryFiltering.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports